import { useEffect } from 'react';

import { useGetTelehealthSessionInfoCallback } from '.';
import { authedAtTimestampAtom } from '../auth/state';
import { logger } from '../datadog';
import { useTrackEvent } from '../segment/segment';
import { EventTypeEnum } from '../segment/types';
import { useAtomCallbackMemoized } from './useAtomCallbackMemoized';

export function useWaitingRoomTrackingEvent(
  event: EventTypeEnum.CLIENT_WAITING_ROOM | EventTypeEnum.PROVIDER_WAITING_ROOM,
  providerShortId?: string,
  patientShortId?: string,
) {
  const [getTelehealthSessionInfo] = useGetTelehealthSessionInfoCallback();
  const { userViewed } = useTrackEvent();
  const getAuthedAtTimestamp = useAtomCallbackMemoized((get) => get(authedAtTimestampAtom), []);

  useEffect(
    function fetchAndTrackWaitingRoomEvent() {
      (async () => {
        if (!providerShortId) {
          return;
        }
        try {
          const { data } = await getTelehealthSessionInfo({
            variables: { providerShortId, patientShortId },
          });
          if (data?.telehealthSessionInfo?.appointment) {
            const { shortId, timeStart } = data.telehealthSessionInfo.appointment;
            const params = {
              appointmentShortId: shortId,
              appointmentTimeStart: timeStart,
              componentName: `${event.toLocaleLowerCase().replace(/\W/g, '_')}_page`,
              componentType: 'page',
              isAuthenticated: !!getAuthedAtTimestamp(),
            };
            userViewed(event, params);
            logger.debug('Submitted tracking event', { event, params });
          }
        } catch (error) {
          logger.warn('Unable to submit tracking event due to missing session info', {}, error as Error);
        }
      })();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [providerShortId],
  );
}
